import { HelpCircle, ShieldCheck, Sparkles, Database } from "lucide-react";
import { PageHeader } from "@/components/shared";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const STEPS = [
  "Create your account with a secure 6-digit email code.",
  "Complete your wedding setup — partners, date, venue and budget.",
  "Add your budget categories and log expenses.",
  "Build your guest list and track RSVPs.",
  "Add your vendors and keep quotes and deposits in one place.",
  "Plan your timeline and calendar.",
  "Create your seating plan.",
  "Organise your wedding-day itinerary.",
  "Track gifts, thank-yous and your honeymoon.",
];

const FAQ = [
  { q: "How is my planner saved?", a: "Your planner is linked to your PlanMyWedding account and stored securely on our service, so you can access it across your phone, tablet and computer. Changes save automatically." },
  { q: "Is my data private?", a: "Yes. Your account data is only accessible through your authenticated account. No other customer can see your guests, budget, photos or personal details." },
  { q: "Can I back up my planner?", a: "Yes — go to Settings › Data and choose Export Backup to download a full JSON copy. You can re-import it anytime." },
  { q: "How do I start over?", a: "Settings › Data › Reset Planner clears your planning data and gives you a fresh start. This can't be undone." },
];

export default function Help() {
  return (
    <div className="max-w-3xl">
      <PageHeader title="Help Center" subtitle="Everything you need to get the most out of PlanMyWedding." testId="help-header" />

      <div className="rounded-2xl bg-card border border-border p-8 mb-6">
        <div className="flex items-center gap-2 mb-5"><Sparkles className="h-5 w-5 text-accent" /><h3 className="text-2xl tracking-tight text-primary">How PlanMyWedding works</h3></div>
        <ol className="space-y-3">
          {STEPS.map((s, i) => (
            <li key={s} className="flex items-start gap-3">
              <span className="h-7 w-7 rounded-full bg-accent/15 text-accent text-sm flex items-center justify-center shrink-0 tnum">{i + 1}</span>
              <span className="text-foreground/90 pt-0.5">{s}</span>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-2xl bg-card border border-border p-8 mb-6">
        <div className="flex items-center gap-2 mb-4"><Database className="h-5 w-5 text-accent" /><h3 className="text-2xl tracking-tight text-primary">Data & privacy</h3></div>
        <p className="text-muted-foreground leading-relaxed">
          PlanMyWedding is a cloud-backed web application. Your planner is linked to your account so you can access it across your devices, and your account data is stored securely on our service — only accessible through your authenticated account.
        </p>
      </div>

      <div className="rounded-2xl bg-card border border-border p-8">
        <div className="flex items-center gap-2 mb-2"><HelpCircle className="h-5 w-5 text-accent" /><h3 className="text-2xl tracking-tight text-primary">Frequently asked</h3></div>
        <Accordion type="single" collapsible className="mt-2">
          {FAQ.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`}>
              <AccordionTrigger className="text-left">{f.q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
